/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { observable, action } from "mobx";
import { fullScreenExitReason } from "constants/enums";
import { getQueryParameterFromUrl } from "dc-preview-utils/src/Utils/UrlUtils";

class PageByPageStore {
  activeMegaVerbBeforeFullScreen;
  reasonOfExitFromFullScreenMode;
  visitedPagesInFullScreen;
  @observable pagePositionFromTop;
  enableFitOneFullPageMode;
  @observable pageByPageScrollTop;
  @observable scrollTopAsPerScrubber;

  constructor() {
    this.init();
  }

  initStore(docApi, stores) {
    if (docApi) {
      this.docApi = docApi;
    }
    if (stores) {
      this.stores = stores;
    }
  }

  @action
  init() {
    this.activeMegaVerbBeforeFullScreen = "NONE";
    this.reasonOfExitFromFullScreenMode = fullScreenExitReason.ESCAPE;
    this.visitedPagesInFullScreen = new Set();
    this.pagePositionFromTop = 0;
    this.enableFitOneFullPageMode = true;
    this.pageByPageScrollTop = 0;
    this.scrollTopAsPerScrubber = 0;
  }

  setActiveMegaVerbBeforeFullScreen() {
    let verb = getQueryParameterFromUrl(window.location.href, "viewer!megaVerb");
    if (!verb) {
      verb = getQueryParameterFromUrl(window.location.href, "viewer%21megaVerb");
    }
    const activeMegaVerb = verb || "NONE";
    this.activeMegaVerbBeforeFullScreen = activeMegaVerb;
  }

  setFullScreenExitReason(reason = fullScreenExitReason.ESCAPE) {
    this.reasonOfExitFromFullScreenMode = reason;
  }

  addInListOfVisitedPages(index) {
    this.visitedPagesInFullScreen.add(index);
  }

  resetVisitedPages() {
    this.visitedPagesInFullScreen.clear();
  }

  @action
  setPagePositionFromTop(value) {
    this.pagePositionFromTop = value;
  }

  setEnableFitOneFullPageMode(value) {
    this.enableFitOneFullPageMode = value;
  }

  @action
  setPageByPageScrollTop(scrollTop) {
    this.pageByPageScrollTop = scrollTop;
  }

  @action
  setScrollTopAsPerScrubber(value) {
    this.scrollTopAsPerScrubber = value;
  }
}

export { PageByPageStore };
